<template>
  <v-container fluid class="my-5">
    <MesaDirectivaConfiguracion />
  </v-container>
</template>

<script>
import MesaDirectivaConfiguracion from '@/components/mesaDirectiva/MesaDirectivaConfiguracion.vue'

export default {
  name: 'mesa_directiva_configuracion',
  components: {
    MesaDirectivaConfiguracion
  }
}
</script>
